import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/digital-marketing/digi-winning.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <h2>Stop Thinking, Start Winning</h2>
            <p>
              Trust TekRevol as your reliable digital marketing company for
              enhanced digital visibility and higher conversions with our
              high-impact strategies.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Transform Your Digital Presence
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
